import React, { useState } from 'react'
import 'babel-polyfill'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { Route, Switch } from 'react-router-dom'
import Hero from './hero'
import { usePrimaryColor, inheritPrimaryColor } from './colors'
import ColorPicker from './color-picker'
import Home, { Contact } from './home'
import NavBar from './nav-bar'
import Team from './team'
import styled from 'styled-components'
import Articles from './articles'
import useElementSize from './use-element-size'
import News from './news'
import Publications from './publications'
import Research from './research'
import Resources from './resources'

const GlobalStyle = createGlobalStyle`
  a {
    color: ${inheritPrimaryColor};
  }
`

const App = ({ data }) => {
  const primaryColor = usePrimaryColor()
  const [navElement, setNavElement] = useState(null)
  const [footerElement, setFooterElement] = useState(null)
  const { height } = useElementSize(navElement)
  const { height: footerHeight } = useElementSize(footerElement)
  return (
    <ThemeProvider theme={{ primaryColor }}>
      <GlobalStyle />
      <div>
        <ColorPicker />
        <Hero />
        <NavBar ref={setNavElement} />
        <Content minHeight={height ? `calc(100vh - ${height}px - ${footerHeight}px)` : '100vh'}>
          <Switch>
            <Route path='/team'>
              <Team data={data} />
            </Route>
            <Route path='/news'>
              <News data={data} />
            </Route>
            <Route path='/publications'>
              <Publications data={data} />
            </Route>
            <Route path='/research'>
              <Research data={data} />
            </Route>
            <Route path='/resources'>
              <Resources data={data} />
            </Route>
            <Route path='/articles'>
              <Articles data={data} />
            </Route>
            <Route path='/' >
              <Home data={data} />
            </Route>
          </Switch>
        </Content>
        <Contact ref={setFooterElement} />
      </div>
    </ThemeProvider>
  )
}

const Content = styled.div`
  min-height: ${p => p.minHeight};
  background-color: white;
  display: flex;
  flex-direction: column;
`

export default App